import { render, staticRenderFns } from "./ZhengMaFenXi.vue?vue&type=template&id=122af8ed&scoped=true&"
import script from "./ZhengMaFenXi.vue?vue&type=script&lang=js&"
export * from "./ZhengMaFenXi.vue?vue&type=script&lang=js&"
import style0 from "./ZhengMaFenXi.vue?vue&type=style&index=0&id=122af8ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122af8ed",
  null
  
)

export default component.exports